import { render, staticRenderFns } from "./carForm.vue?vue&type=template&id=6ff0caee&scoped=true&"
import script from "./carForm.vue?vue&type=script&lang=js&"
export * from "./carForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff0caee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ff0caee')) {
      api.createRecord('6ff0caee', component.options)
    } else {
      api.reload('6ff0caee', component.options)
    }
    module.hot.accept("./carForm.vue?vue&type=template&id=6ff0caee&scoped=true&", function () {
      api.rerender('6ff0caee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/CarForm/carForm.vue"
export default component.exports